import { cva, type VariantProps } from "../../lib";

export const tabItemVariants = cva(
  [
    // Figma's idle fill
    // `group`: the label and icon darken with the fill on hover
    "px-spacing-lg bg-luce-neutral-background-default group relative flex flex-row items-end justify-center transition-colors",
    // At least 44 wide (a one-letter tab too), and free to shrink to that,
    // truncating its label, so the bar fits its width. More tabs than fit at
    // 44 each need scrolling, which isn't built (a logged gap)
    "min-w-touch-target shrink",
    // Keyboard focus on web: the shared ring (DQ3), inset as ListItem's and
    // Accordion's, so neither the next tab's fill nor a screen's edge can cut
    // it off. The selected indicator covers part of its bottom edge (a logged
    // gap). `web:`, since css-interop drops `:focus-visible` on native
    "web:outline-none web:focus-visible:ring-focus web:focus-visible:ring-luce-brand-primaryBorder web:focus-visible:ring-offset-focus web:focus-visible:ring-inset",
  ].join(" "),
  {
    variants: {
      fullWidth: {
        true: "native:flex-1 w-full",
        false: "w-auto",
      },
      // Hover fills only where a pointer can hover, so a tapped tab on a phone
      // doesn't keep one (Ardhi, DQ15), and only an enabled tab: the media
      // rule comes after `disabled:` in the CSS. A disabled tab is its colours
      // alone: the attenuated label on the intermediate fill, with no fade on
      // top (DQ11)
      active: {
        true: [
          "[@media(hover:hover)]:enabled:hover:bg-luce-brand-primarySurface",
          "disabled:bg-luce-neutral-background-intermediate",
          "disabled:cursor-not-allowed",
        ].join(" "),
        false: [
          "[@media(hover:hover)]:enabled:hover:bg-luce-neutral-background-intermediate",
          "disabled:bg-luce-neutral-background-intermediate",
          "disabled:cursor-not-allowed",
        ].join(" "),
      },
    },
    defaultVariants: {
      fullWidth: false,
      active: false,
    },
  },
);

export type TabItemVariantsProps = VariantProps<typeof tabItemVariants>;
